import React from "react";
import { Flex, FormControl, FormLabel } from "@chakra-ui/react";
import { IOperationRuleAlertUser } from "stores/data/insightAlerts/insightAlertModel";
import UsersSelectionTable from "./UsersSelectionTable";
import SelectedUsersBar from "./SelectedUsersBar";

interface AlertUserSelectionProps {
  t: (key: string) => string;
  alertUsers: IOperationRuleAlertUser[];
  usersTableSelected: React.Key[];
  setUsersTableSelected: (keys: React.Key[]) => void;
  setFieldValue: (field: string, value: any) => void;
  operationRuleAlertUserSelected: IOperationRuleAlertUser[];
  setOperationRuleAlertUserSelected: (users: IOperationRuleAlertUser[]) => void;
  onUsersSelectionChange: (
    selectedRowKeys: React.Key[],
    selectedRows: IOperationRuleAlertUser[]
  ) => void;
  disabled?: boolean;
}

export const AlertUserSelection: React.FC<AlertUserSelectionProps> = ({
  t,
  alertUsers,
  usersTableSelected,
  setUsersTableSelected,
  setFieldValue,
  operationRuleAlertUserSelected,
  setOperationRuleAlertUserSelected,
  onUsersSelectionChange,
  disabled = false,
}) => {
  const handleRemoveUser = (userId: number) => {
    const nextSelectedKeys = usersTableSelected.filter((k) => k !== userId);
    const nextSelectedUsers = alertUsers.filter((user) =>
      nextSelectedKeys.includes(user.userId)
    );
    onUsersSelectionChange(nextSelectedKeys, nextSelectedUsers);
  };

  const handleClearAll = () => {
    setUsersTableSelected([]);
    setOperationRuleAlertUserSelected([]);
    setFieldValue("selectedUsers", []);
  };

  return (
    <Flex direction={"column"} gap={2}>
      <FormControl isRequired>
        <FormLabel color="#414651" fontWeight={"500"}>
          {t("userToReceiveAlert")}
        </FormLabel>
      </FormControl>

      <UsersSelectionTable
        users={alertUsers}
        selectedKeys={usersTableSelected}
        onSelectionChange={onUsersSelectionChange}
        t={t}
        disabled={disabled}
        selectedUsersBar={
          <SelectedUsersBar
            maxVisible={5}
            selectedUsers={operationRuleAlertUserSelected}
            onRemove={handleRemoveUser}
            onClearAll={handleClearAll}
            t={t}
            disabled={disabled}
          />
        }
      />
    </Flex>
  );
};
